import { render } from "./GsDoc.vue?vue&type=template&id=5abe091e&scoped=true"
import script from "./GsDoc.vue?vue&type=script&lang=ts"
export * from "./GsDoc.vue?vue&type=script&lang=ts"

import "./GsDoc.vue?vue&type=style&index=0&id=5abe091e&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-5abe091e"

export default script